// src/containers/Codes/index.js

import colorCodes from './colorCodes';
import stylesCodes from './stylesCodes';
import manufacturingCodes from './manufacturingCodes';
import materialsCodes from './materialsCodes';
import deliveryCodes from './deliveryCodes';
import usageCodes from './usageCodes';
import originsCodes from './originsCodes';
import featuresCodes from './featuresCodes';
import titleStringsCodes from './titleStringsCodes';
import regionCodes from './regionCodes';


// Export all CodeSet instances
export {
  titleStringsCodes,  // done
  featuresCodes,  // done
  originsCodes,  // done
  usageCodes,  // done
  deliveryCodes,  // done
  materialsCodes,  // done
  manufacturingCodes,  // done
  stylesCodes,  // done
  colorCodes,  // done
  regionCodes  // done
};

// Export codeSetMapping
export const codeSetMapping = {
  'mainColors': colorCodes,
  'highlightColors': colorCodes,
  'styles': stylesCodes,
  'manufacturing': manufacturingCodes,
  'weavedMaterials': materialsCodes,
  'foundationMaterial': materialsCodes,
  'delivery': deliveryCodes,
  'usage': usageCodes,
  'origins': originsCodes,
  'features': featuresCodes,
  'region': regionCodes
};

// Export additional constants
export const priceRangesCodes = [0, 600, 1600];

export const pileRangesCodes = [0, 5, 10];
